// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"AdminAvatarsPage_contentWrapper__72pgd","error":"AdminAvatarsPage_error__2__5Y"};